import React, {Component} from "react";
import {
    FormSection,
    Hint,
    Link,
    SectionBody,
    SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import {STYLE_LINK} from "../Styles/style";

export class MessageComponent extends Component {
    render() {
        return <FormSection theme={this.props.theme}>
            <SectionHeader theme={this.props.theme}>{I18n.get(this.props.title)}</SectionHeader>
            <SectionBody theme={this.props.theme}>
                <Hint theme={this.props.theme}>
                    {I18n.get(this.props.hint)}
                    <Hint theme={this.props.theme}>
                        <Link theme={this.props.theme}  style={STYLE_LINK} onClick={this.props.changeStateFunc}>
                            {I18n.get(this.props.linkName)}
                        </Link>
                    </Hint>
                </Hint>

            </SectionBody>
        </FormSection>;
    }
}

MessageComponent.propTypes = {
    theme: PropTypes.any,
    changeStateFunc: PropTypes.func,
    title: PropTypes.string,
    hint: PropTypes.string,
    linkName: PropTypes.string
};